import { useEffect, useMemo } from 'react';
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const SULLANA_CENTER = [-4.9039, -80.6853];

const toCoordinate = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

const normalizeCoordinates = (coordinates) => {
  const lat = toCoordinate(coordinates?.lat ?? coordinates?.latitud);
  const lng = toCoordinate(coordinates?.lng ?? coordinates?.longitud);
  return lat !== null && lng !== null ? { lat, lng } : null;
};

const MapClickHandler = ({ onSelect }) => {
  useMapEvents({
    click(event) {
      onSelect({ lat: event.latlng.lat, lng: event.latlng.lng });
    },
  });

  return null;
};

const MapViewSync = ({ coordinates, isVisible }) => {
  const map = useMap();

  useEffect(() => {
    if (!isVisible) return;
    window.setTimeout(() => {
      map.invalidateSize();
      if (coordinates) {
        map.setView([coordinates.lat, coordinates.lng], Math.max(map.getZoom(), 16));
      }
    }, 120);
  }, [coordinates, isVisible, map]);

  return null;
};

const MapSelector = ({ coordinates, onChange, isVisible = true }) => {
  const selectedCoordinates = useMemo(() => normalizeCoordinates(coordinates), [coordinates]);
  const center = selectedCoordinates
    ? [selectedCoordinates.lat, selectedCoordinates.lng]
    : SULLANA_CENTER;

  return (
    <div className="h-[380px] w-full overflow-hidden rounded-lg border border-slate-200">
      <MapContainer center={center} zoom={selectedCoordinates ? 16 : 13} className="h-full w-full">
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <MapClickHandler onSelect={onChange} />
        <MapViewSync coordinates={selectedCoordinates} isVisible={isVisible} />
        {selectedCoordinates && (
          <Marker position={[selectedCoordinates.lat, selectedCoordinates.lng]} />
        )}
      </MapContainer>
    </div>
  );
};

export default MapSelector;
